module.exports = __webpack_public_path__ + "0586356e20038aea85786e8dfcc988d5.svg";